import { h } from 'preact'

export const AdsLiensCommerciaux = ({ adsId }) => {
   return (
      <div className="container-fluid">
         <div id={adsId} className="mb-4" widget-id="SF_1" data-testid="bande-liens-commerciaux"></div>
      </div>
   )
}
